import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Tracking } from '@panamax/app-state';
import { genericTracingTransformer } from '@shared/tracking/tracing/generic-tracing-transformer';
import { OrderHeader } from '@usf/ngrx-order';
import { viewExceptionLinkClickTrace } from './models/view-exceptions-link-click.trace';
import { MY_ORDERS_TRACING_ACTIONS } from './my-orders-tracing.actions';
import { MyOrdersTracingMessages } from './my-orders-tracing.constants';
import { viewExceptionLinkTraceTransformer } from './my-orders-tracing.transformers';

@Injectable({
  providedIn: 'root',
})
export class MyOrdersTracingService {
  constructor(private store: Store) {}

  traceViewExceptionsLinkClick(
    orderHeader: OrderHeader,
    isOrderStatusPage: boolean,
  ): void {
    const tracking = JSON.parse(JSON.stringify(viewExceptionLinkClickTrace));
    tracking.tracing.data.attributes.order.orderId = orderHeader.orderId;
    tracking.tracing.data.attributes.order.tandemOrderNumber =
      orderHeader.tandemOrderNumber;
    tracking.tracing.data.attributes.order.origOrderId =
      orderHeader.origOrderId;
    tracking.tracing.data.attributes.order.origSplitOrderId =
      orderHeader.origSplitOrderId;
    tracking.tracing.data.attributes.order.customerNumber =
      orderHeader.customerNumber;
    tracking.tracing.data.attributes.order.divisionNumber =
      orderHeader.divisionNumber;
    tracking.tracing.data.attributes.order.departmentNumber =
      orderHeader.departmentNumber;
    tracking.tracing.data.attributes.order.requestedDeliveryDate =
      orderHeader.requestedDeliveryDate;
    tracking.tracing.data.attributes.order.confirmedDeliveryDate =
      orderHeader.confirmedDeliveryDate;
    tracking.tracing.data.attributes.order.totalAmount = orderHeader.totalPrice;
    tracking.tracing.data.attributes.event = isOrderStatusPage
      ? MyOrdersTracingMessages.viewExceptionLinkClickOnOrderStatusEvent
      : MyOrdersTracingMessages.viewExceptionLinkClickOnMyOrdersEvent;
    tracking.tracing.transformFunc = genericTracingTransformer;

    this.store.dispatch(
      isOrderStatusPage
        ? MY_ORDERS_TRACING_ACTIONS.traceResolveExceptionButtonClickOnOrderStatus(
            { tracking },
          )
        : MY_ORDERS_TRACING_ACTIONS.traceResolveExceptionButtonClickOnMyOrders({
            tracking,
          }),
    );
  }
}
